import Image from "next/image";
import {
  // New icons for engagement dashboard
  Activity,
  AlertCircle,
  AlertTriangle,
  AlignHorizontalDistributeCenter,
  Archive,
  ArrowDown,
  ArrowDownAZ,
  ArrowLeft,
  ArrowRight,
  ArrowRightLeft,
  ArrowUp,
  ArrowUpFromDot,
  Award,
  BarChart,
  BarChart3,
  Bell,
  BellPlus,
  BookOpen,
  BrainCircuit,
  Cable,
  Calendar,
  CalendarDays,
  CandlestickChart,
  Castle,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  CircuitBoard,
  ClipboardSignature,
  Clock,
  Code,
  Cog,
  Coins,
  Compass,
  Construction,
  CreditCard,
  Crown,
  Database,
  DollarSign,
  Download,
  DraftingCompass,
  Edit,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileText,
  Flame,
  Flame as FlameIcon,
  FlaskRound,
  Footprints,
  Fuel,
  Gift,
  Grid3X3,
  Group,
  Heart,
  HeartHandshake,
  HelpCircle,
  HelpCircle as HelpCircleIcon,
  History,
  Image as ImageIcon,
  Inbox,
  Landmark,
  Laptop,
  Link,
  List,
  ListTree,
  Loader2,
  Lock,
  LucideIcon,
  LucideProps,
  Mail,
  MapPin,
  Menu,
  MessageSquare,
  MessageSquareDashed,
  Minus,
  Monitor,
  Moon,
  MoreHorizontal,
  MoreVertical,
  Network,
  Package,
  Paperclip,
  Pencil,
  Phone,
  PieChart,
  Plus,
  Rabbit,
  Radio,
  Receipt,
  ReceiptText,
  RefreshCw,
  Reply,
  Rocket,
  ScatterChart,
  Search,
  Send,
  Settings,
  Settings2,
  Share,
  Shield,
  ShieldOff,
  Smartphone,
  SmilePlus,
  Loader2 as Spinner,
  Star,
  SunMedium,
  Target,
  ThumbsUp,
  Timer,
  Trash,
  TrendingDown,
  TrendingUp,
  Trophy,
  Upload,
  User,
  UserCheck,
  UserCog,
  UserPlus,
  Users,
  Vault,
  Video,
  Vote,
  Wallet,
  Wifi,
  X,
  XCircle,
  Zap,
} from "lucide-react";

export type Icon = LucideIcon;

export const Icons = {
  ethereum: ({ ...props }: LucideProps) => (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <path d="M11.944 17.97L4.58 13.62 11.943 24l7.37-10.38-7.372 4.35h.003zM12.056 0L4.69 12.223l7.365 4.354 7.365-4.35L12.056 0z" />
    </svg>
  ),
  apple: ({ ...props }: LucideProps) => (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.54 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701" />
    </svg>
  ),
  award: Award,
  bellPlus: BellPlus,
  castle: Castle,
  circuitBoard: CircuitBoard,
  clipboardSignature: ClipboardSignature,
  construction: Construction,
  flame: Flame,
  arrowDownAZ: ArrowDownAZ,
  listTree: ListTree,
  messageSquareDashed: MessageSquareDashed,
  pencil: Pencil,
  smilePlus: SmilePlus,
  timer: Timer,
  userCog: UserCog,
  arrowUpFromDot: ArrowUpFromDot,
  crown: Crown,
  draftingCompass: DraftingCompass,
  vaults: Vault,
  cable: Cable,
  candlestickChart: CandlestickChart,
  brainCircuit: BrainCircuit,
  trendingUp: TrendingUp,
  wallet: Wallet,
  terminal: CandlestickChart,
  strategies: AlignHorizontalDistributeCenter,
  portfolio: PieChart,
  explore: Compass,
  heartHandshake: HeartHandshake,
  marketSignals: Radio,
  marketWeb: Network,
  whaleWatch: Footprints,
  group: Group,
  add: Plus,
  arrowRight: ArrowRight,
  billing: ReceiptText,
  topup: Fuel,
  payments: Wallet,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  check: Check,
  rabbit: Rabbit,
  close: X,
  ellipsis: MoreVertical,
  // New icons for engagement dashboard
  Activity: Activity,
  Archive: Archive,
  ArrowDown: ArrowDown,
  ArrowUp: ArrowUp,
  BarChart: BarChart,
  BarChart3: BarChart3,
  Bell: Bell,
  BookOpen: BookOpen,
  Calendar: Calendar,
  CalendarDays: CalendarDays,
  CheckCircle: CheckCircle,
  Clock: Clock,
  Coins: Coins,
  DollarSign: DollarSign,
  Eye: Eye,
  EyeOff: EyeOff,
  Gift: Gift,
  Grid3X3: Grid3X3,
  Heart: Heart,
  Inbox: Inbox,
  Link: Link,
  List: List,
  Mail: Mail,
  MapPin: MapPin,
  MessageSquare: MessageSquare,
  Minus: Minus,
  Monitor: Monitor,
  MoreHorizontal: MoreHorizontal,
  PieChart: PieChart,
  Phone: Phone,
  RefreshCw: RefreshCw,
  Send: Send,
  Shield: Shield,
  Smartphone: Smartphone,
  Star: Star,
  Target: Target,
  ThumbsUp: ThumbsUp,
  TrendingDown: TrendingDown,
  TrendingUp: TrendingUp,
  Trophy: Trophy,
  Upload: Upload,
  UserCheck: UserCheck,
  UserPlus: UserPlus,
  Users: Users,
  Video: Video,
  Vote: Vote,
  XCircle: XCircle,
  Zap: Zap,
  Package: Package,
  Database: Database,
  ExternalLink: ExternalLink,
  Sparkles: ScatterChart,
  Rocket: Rocket,
  CandlestickChart: CandlestickChart,
  FlameIcon: FlameIcon,
  AlertCircle: AlertCircle,
  AlertTriangle: AlertTriangle,
  HelpCircleIcon: HelpCircleIcon,
  Wifi: Wifi,
  Paperclip: Paperclip,
  Spinner: Spinner,
  Share: Share,
  Reply: Reply,
  Receipt: Receipt,
  Download: Download,
  Plus: Plus,
  X: X,
  CreditCard: CreditCard,
  FileText: FileText,
  Edit: Edit,
  History: History,
  Image: ImageIcon,
  ArrowRightLeft: ArrowRightLeft,
  Crown: Crown,
  MoreVertical: MoreVertical,
  Lock: Lock,
  ShieldOff: ShieldOff,
  ArrowLeft: ArrowLeft,
  Code: Code,
  // PascalCase mappings for engagement-actions
  Award: Award,
  ChevronDown: ChevronDown,
  ClipboardSignature: ClipboardSignature,
  Flame: Flame,
  HelpCircle: HelpCircleIcon,
  SmilePlus: SmilePlus,
  dashboard: ({ ...props }: LucideProps) => (
    <svg
      width="64px"
      height="64px"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M822.8 466.5c0.1 0.3 0.2 0.5 0.3 0.8-0.1-0.2-0.2-0.5-0.3-0.8zM593.4 665.2c0-0.1-0.1-0.2-0.1-0.3 0 0.1 0.1 0.2 0.1 0.3zM834.7 508c0.1 0.4 0.2 0.9 0.3 1.3-0.1-0.4-0.2-0.8-0.3-1.3zM820 459.5c0.1 0.3 0.2 0.6 0.4 0.8-0.2-0.2-0.3-0.5-0.4-0.8zM831.5 493.9c0.1 0.3 0.2 0.7 0.3 1-0.1-0.3-0.2-0.6-0.3-1zM817.1 453c0.2 0.4 0.4 0.9 0.6 1.3-0.2-0.4-0.4-0.9-0.6-1.3zM825.2 472.8c0.1 0.4 0.3 0.8 0.4 1.2-0.1-0.3-0.3-0.7-0.4-1.2zM594.7 668c0-0.1-0.1-0.1-0.1-0.2 0 0.1 0 0.2 0.1 0.2zM630.4 656.5c-0.3 0.2-0.5 0.5-0.8 0.7 0.2-0.3 0.5-0.5 0.8-0.7zM829.7 487c0.1 0.4 0.2 0.7 0.3 1.1-0.1-0.3-0.2-0.7-0.3-1.1zM791.6 410.8l0.9 1.2-0.9-1.2zM623.7 663.4c-0.8 1-1.6 2.2-2.4 3.3 0.8-1.2 1.6-2.3 2.4-3.3zM803.8 428.3c0.1 0.2 0.3 0.4 0.4 0.6-0.1-0.1-0.2-0.3-0.4-0.6zM621.3 666.8l-1.2 1.8 1.2-1.8zM799.9 422.2c0.3 0.5 0.6 1 1 1.4-0.4-0.4-0.7-0.9-1-1.4zM626.4 660.2c-0.3 0.4-0.7 0.7-1 1.1 0.3-0.3 0.7-0.7 1-1.1zM592.2 662.2c-0.1-0.2-0.1-0.3-0.2-0.5 0.1 0.2 0.2 0.3 0.2 0.5zM807.5 434.4c0.2 0.4 0.5 0.8 0.7 1.2-0.2-0.4-0.5-0.8-0.7-1.2zM613.5 682.3c-0.2 0.4-0.3 0.8-0.5 1.3 0.2-0.4 0.3-0.8 0.5-1.3zM814.4 447.2zM810.7 440.2c0.2 0.4 0.5 0.9 0.7 1.3-0.2-0.5-0.5-0.9-0.7-1.3zM624.9 662c-0.4 0.4-0.7 0.9-1.1 1.3 0.4-0.5 0.7-0.9 1.1-1.3zM607.9 687.7l-0.2-0.2 0.2 0.2zM699.6 702.5c-0.1-0.1-0.2-0.2-0.2-0.3 0 0.2 0.1 0.2 0.2 0.3zM632.2 655c-0.2 0.2-0.4 0.3-0.6 0.5 0.2-0.1 0.4-0.3 0.6-0.5zM627.2 659.4l1.4-1.4-1.4 1.4zM610.7 690.4c-0.5-0.4-1-0.9-1.5-1.4 0.5 0.5 1 0.9 1.5 1.4zM846 571.5l-5.4-3.8 8.2 5.7zM615.1 678.5c-0.3 0.6-0.5 1.2-0.8 1.8 0.3-0.6 0.5-1.2 0.8-1.8zM698.2 701.1zM590 655.7c-0.1-0.3-0.2-0.5-0.2-0.8 0.1 0.2 0.2 0.5 0.2 0.8zM616.7 674.9c1.1-2.2 2.2-4.2 3.3-6.2-1.7 2.9-3.4 6-4.9 9.5 0.5-1.1 1.1-2.2 1.6-3.3zM787.4 405.7c0.4 0.5 0.7 0.9 1.1 1.4-0.3-0.5-0.7-1-1.1-1.4zM591.1 659c-0.1-0.2-0.2-0.4-0.2-0.7 0.1 0.3 0.1 0.5 0.2 0.7zM838.1 529zM839.9 548.9c0 0.7 0.1 1.3 0.1 2 0-0.6-0.1-1.3-0.1-2zM634.6 653.5c-0.2 0.1-0.4 0.2-0.6 0.4 0.2-0.2 0.4-0.3 0.6-0.4zM835.9 514.4l0.3 1.5-0.3-1.5zM612 686.3c-0.1 0.2-0.2 0.5-0.2 0.7 0.1-0.2 0.2-0.5 0.2-0.7zM837 521.2c0.1 0.4 0.1 0.7 0.2 1.1-0.1-0.3-0.1-0.7-0.2-1.1zM839.4 542c0.1 0.7 0.1 1.5 0.2 2.2-0.1-0.7-0.2-1.4-0.2-2.2zM796.2 417c0.2 0.3 0.4 0.6 0.7 0.9-0.2-0.2-0.4-0.6-0.7-0.9zM595.9 670.7zM636.6 652.3l-0.6 0.3 0.6-0.3zM838.8 535.4c0.1 0.6 0.1 1.2 0.2 1.9-0.1-0.6-0.1-1.3-0.2-1.9z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M822.6 644.9l14.4 6.4c12.4 5.5 21.5 18.3 27.9 39.1 8-7.1 16.9-19.1 21.9-39.2 10.7-42.6-37.6-77.4-38.1-77.8l-8.2-5.7-0.3-10c-0.1-2.3-0.2-4.5-0.3-6.7 0-0.7-0.1-1.4-0.1-2-0.1-1.6-0.2-3.1-0.3-4.7-0.1-0.7-0.1-1.5-0.2-2.2-0.1-1.6-0.3-3.2-0.4-4.7-0.1-0.6-0.1-1.2-0.2-1.9-0.2-2.2-0.5-4.3-0.7-6.4l-0.9-6.6c-0.1-0.4-0.1-0.7-0.2-1.1-0.3-1.8-0.5-3.6-0.8-5.3l-0.3-1.5-0.9-5.1c-0.1-0.4-0.2-0.9-0.3-1.3-0.4-2.1-0.8-4.1-1.3-6.2-0.5-2.3-1.1-4.6-1.6-6.9-0.1-0.3-0.2-0.7-0.3-1-0.5-2-1-3.9-1.6-5.8-0.1-0.4-0.2-0.7-0.3-1.1-1.3-4.4-2.6-8.7-4.1-12.9-0.1-0.4-0.3-0.8-0.4-1.2-0.7-1.9-1.3-3.7-2-5.5-0.1-0.3-0.2-0.5-0.3-0.8-0.8-2.1-1.6-4.1-2.5-6.2-0.1-0.3-0.2-0.6-0.4-0.8-0.7-1.7-1.5-3.5-2.3-5.2-0.2-0.4-0.4-0.9-0.6-1.3-0.9-1.9-1.8-3.9-2.7-5.8-1-1.9-2-3.9-3-5.8-0.2-0.4-0.5-0.9-0.7-1.3-0.8-1.5-1.7-3-2.5-4.5-0.2-0.4-0.5-0.8-0.7-1.2-1.1-1.8-2.1-3.6-3.3-5.4-0.1-0.2-0.3-0.4-0.4-0.6-1-1.6-2-3.1-3-4.7-0.3-0.5-0.6-1-1-1.4-1-1.4-2-2.9-3-4.3-0.2-0.3-0.4-0.6-0.7-0.9-1.2-1.7-2.4-3.3-3.7-5l-0.9-1.2c-1-1.3-2-2.6-3-3.8-0.4-0.5-0.7-0.9-1.1-1.4-1.3-1.6-2.7-3.2-4-4.8-17.8-20.3-35.6-32.4-45.6-38.2-9.9 5.8-27.7 17.9-45.6 38.2-35.6 40.6-54.8 93.3-56.9 156.8l-0.3 10-8.2 5.7c-0.4 0.3-48.8 35.1-38 77.7 0.3 1.3 0.7 2.5 1 3.7 0.1 0.3 0.2 0.5 0.2 0.8 0.3 0.9 0.5 1.8 0.8 2.7 0.1 0.2 0.2 0.4 0.2 0.7l0.9 2.7c0.1 0.2 0.1 0.3 0.2 0.5 0.3 0.9 0.7 1.8 1 2.7 0 0.1 0.1 0.2 0.1 0.3l1.2 2.7c0 0.1 0.1 0.1 0.1 0.2 0.4 0.9 0.8 1.8 1.3 2.7 0.9 1.8 1.9 3.5 2.8 5.1 2.9 4.7 5.9 8.5 8.9 11.6l0.2 0.2 1.3 1.3c0.5 0.5 1 0.9 1.5 1.4 0.4-1.1 0.7-2.3 1.1-3.4 0.1-0.2 0.2-0.5 0.2-0.7 0.3-0.9 0.6-1.8 1-2.7 0.2-0.4 0.3-0.9 0.5-1.3 0.3-0.7 0.5-1.4 0.8-2.1 0.2-0.6 0.5-1.2 0.8-1.8 0-0.1 0.1-0.1 0.1-0.2 1.5-3.5 3.2-6.7 4.9-9.5l0.1-0.1 1.2-1.8 0.1-0.1c0.8-1.2 1.6-2.3 2.4-3.3l0.1-0.1c0.3-0.4 0.7-0.9 1.1-1.3 0.2-0.2 0.4-0.4 0.5-0.6 0.3-0.4 0.7-0.8 1-1.1l0.8-0.8c0.5-0.5 0.9-1 1.4-1.4 0.3-0.3 0.6-0.6 1-0.9 0.3-0.2 0.5-0.5 0.8-0.7l1.2-0.9c0.2-0.2 0.4-0.3 0.6-0.5l1.8-1.2c0.2-0.1 0.4-0.2 0.6-0.4l1.5-0.9 0.6-0.3c0.7-0.4 1.3-0.7 2-1l14.4-6.4 9.6 12.5c1.9 2.4 3.8 4.9 5.8 7.4 9.5 12.1 19.7 24.7 27.1 33.2 1 1.1 1.9 2.1 2.7 3.1 0.4 0.4 0.7 0.8 1.1 1.2 0.1 0.1 0.2 0.2 0.2 0.3 0.4 0.4 0.7 0.8 1 1.1H775c8.3-8.8 24.7-29 38-46.3l9.6-12.8z m-87.1-87.6c-31.2 0-56.5-25.4-56.5-56.5 0-31.2 25.4-56.5 56.5-56.5s56.5 25.4 56.5 56.5-25.3 56.5-56.5 56.5z"
          fill="#E6E6E6"
        ></path>
        <path
          d="M663.8 372.7c32.5-36.3 64.8-50.4 66.1-51l7.9-3.4 7.9 3.4c1.4 0.6 33.7 14.7 66.1 51 11 12.3 22.9 28.1 33.6 47.9C843.2 284.3 731.5 174 594.6 174c-100.8 0-191 60-230.4 151.3 8.5 3 16.7 6.6 24.7 10.7 27.4 14.2 51.5 34.8 69.8 59.7 6.5 8.9 4.6 21.4-4.3 28-8.9 6.5-21.4 4.6-28-4.3-30.3-41.2-78.9-65.8-129.9-65.8-88.9 0-161.1 72.3-161.1 161.1 0 88.9 72.3 161.1 161.1 161.1h258.1c-1.7-4.7-3.3-9.6-4.6-15-14.1-55.9 27.5-98.4 45.8-113.9 5.1-86.6 39.5-142.4 68-174.2z m-151-109.2c-33 18.9-49.4 44.6-49.6 44.9-1.9 3-5.2 4.7-8.5 4.7-1.8 0-3.7-0.5-5.3-1.5-4.7-2.9-6.1-9.1-3.1-13.8 0.8-1.2 19.3-30.2 56.6-51.6 34.4-19.7 91.8-36.4 170-4.1 5.1 2.1 7.5 8 5.4 13.1-2.1 5.1-8 7.5-13.1 5.4-56.7-23.5-108-22.5-152.4 2.9z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M646.5 711.3c2.3-0.4 4.6-0.8 6.8-1.3-1.7-2-3.3-4-4.9-6-0.7 2.3-1.4 4.8-1.9 7.3z"
          fill="#005BFF"
        ></path>
        <path
          d="M827.3 704c1.7 5.8 3.1 12.4 4 18.5l2.7 20.6 20.5-3.5c2.2-0.4 53.9-9.9 71.2-78.7 14.1-55.9-27.5-98.4-45.8-113.9-0.9-15.2-2.7-29.4-5.2-42.8 7.2-25.5 10.9-52.1 10.9-79.3 0-77.7-30.3-150.8-85.2-205.7-55-55-128-85.2-205.7-85.2-119.1 0-225.5 72.3-269.7 181.6-9.4-1.3-18.9-2-28.3-2-110.9 0-201.1 90.2-201.1 201.1s90.2 201.1 201.1 201.1h283c19.6 19.6 40.3 23.5 41.7 23.7l20.4 3.4 2.7-20.5c0.5-3.7 1.2-7.5 2.1-11.2 0.6-2.5 1.2-5 1.9-7.3 1.6 2 3.3 4 4.9 6 10.5 12.8 21.4 25.2 27.6 29.8l5.3 3.9h103.3l5.3-3.9c7-5.2 20.5-21.1 32.4-35.7zM550 660.9c1.3 5.3 2.9 10.3 4.6 15H296.5c-88.9 0-161.1-72.3-161.1-161.1 0-88.9 72.3-161.1 161.1-161.1 51.1 0 99.6 24.6 129.9 65.8 6.5 8.9 19.1 10.8 28 4.3 8.9-6.5 10.8-19.1 4.3-28-18.3-24.9-42.4-45.5-69.8-59.7-8-4.1-16.2-7.7-24.7-10.7C403.6 234 493.8 174 594.6 174c136.9 0 248.6 110.3 250.9 246.7-10.7-19.8-22.6-35.7-33.6-47.9-32.5-36.3-64.8-50.4-66.1-51l-7.9-3.4-7.9 3.4c-1.4 0.6-33.7 14.7-66.1 51-28.5 31.8-62.9 87.6-68 174.3-18.4 15.4-60 57.9-45.9 113.8z m225 42.8h-74.4c-0.3-0.4-0.7-0.7-1-1.1-0.1-0.1-0.2-0.2-0.2-0.3-0.4-0.4-0.7-0.8-1.1-1.2-8.8-9.8-23.5-27.9-35.6-43.7l-9.6-12.5-14.4 6.4c-0.7 0.3-1.4 0.6-2 1l-0.6 0.3-1.5 0.9c-0.2 0.1-0.4 0.2-0.6 0.4l-1.8 1.2c-0.2 0.2-0.4 0.3-0.6 0.5l-1.2 0.9c-0.3 0.2-0.5 0.5-0.8 0.7-0.3 0.3-0.6 0.6-1 0.9-0.5 0.5-1 0.9-1.4 1.4l-0.8 0.8c-0.3 0.4-0.7 0.7-1 1.1-0.2 0.2-0.4 0.4-0.5 0.6-0.4 0.4-0.7 0.9-1.1 1.3l-0.1 0.1-2.4 3.3-0.1 0.1-1.2 1.8-0.1 0.1c-1.2 1.9-2.3 4-3.3 6.2-0.5 1.1-1 2.2-1.6 3.4 0 0.1-0.1 0.1-0.1 0.2-0.3 0.6-0.5 1.2-0.8 1.8-0.3 0.7-0.6 1.4-0.8 2.1-0.2 0.4-0.3 0.8-0.5 1.3-0.3 0.9-0.7 1.8-1 2.7-0.1 0.2-0.2 0.5-0.2 0.7-0.4 1.1-0.7 2.2-1.1 3.4-0.5-0.4-1-0.9-1.5-1.4l-1.3-1.3-0.2-0.2c-4-4.1-8.2-9.6-11.8-16.8-0.4-0.9-0.9-1.8-1.3-2.7 0-0.1-0.1-0.1-0.1-0.2l-1.2-2.7c0-0.1-0.1-0.2-0.1-0.3-0.4-0.9-0.7-1.8-1-2.7-0.1-0.2-0.1-0.3-0.2-0.5l-0.9-2.7c-0.1-0.2-0.2-0.4-0.2-0.7-0.3-0.9-0.6-1.8-0.8-2.7-0.1-0.3-0.2-0.5-0.2-0.8-0.3-1.2-0.7-2.4-1-3.7-10.7-42.6 37.6-77.4 38-77.7l8.2-5.7 0.3-10c2.1-63.5 21.2-116.2 56.9-156.8 17.9-20.3 35.7-32.4 45.6-38.2 9.9 5.8 27.7 17.9 45.6 38.2 1.4 1.6 2.7 3.2 4 4.8 0.4 0.5 0.7 0.9 1.1 1.4 1 1.3 2 2.5 3 3.8l0.9 1.2c1.3 1.6 2.5 3.3 3.7 5 0.2 0.3 0.4 0.6 0.7 0.9 1 1.4 2 2.8 3 4.3 0.3 0.5 0.6 1 1 1.4 1 1.5 2 3.1 3 4.7 0.1 0.2 0.3 0.4 0.4 0.6l3.3 5.4c0.2 0.4 0.5 0.8 0.7 1.2 0.9 1.5 1.7 3 2.5 4.5 0.2 0.4 0.5 0.9 0.7 1.3 1 1.9 2 3.8 3 5.8 0.9 1.9 1.9 3.8 2.7 5.8 0.2 0.4 0.4 0.9 0.6 1.3 0.8 1.7 1.5 3.4 2.3 5.2 0.1 0.3 0.2 0.6 0.4 0.8 0.9 2 1.7 4.1 2.5 6.2 0.1 0.3 0.2 0.5 0.3 0.8 0.7 1.8 1.4 3.7 2 5.5 0.1 0.4 0.3 0.8 0.4 1.2 1.5 4.2 2.8 8.6 4.1 12.9 0.1 0.4 0.2 0.7 0.3 1.1 0.5 1.9 1.1 3.9 1.6 5.8 0.1 0.3 0.2 0.7 0.3 1 1.1 4.3 2.1 8.7 2.9 13.1 0.1 0.4 0.2 0.9 0.3 1.3l0.9 5.1 0.3 1.5c0.3 1.8 0.6 3.5 0.8 5.3 0.1 0.4 0.1 0.7 0.2 1.1l0.9 6.6c0.3 2.1 0.5 4.3 0.7 6.4 0.1 0.6 0.1 1.2 0.2 1.9 0.1 1.6 0.3 3.1 0.4 4.7 0.1 0.7 0.1 1.5 0.2 2.2 0.1 1.6 0.2 3.1 0.3 4.7 0 0.7 0.1 1.3 0.1 2 0.1 2.2 0.2 4.5 0.3 6.7l0.3 10 5.5 3.8 2.7 1.9c0.5 0.3 48.8 35.1 38.1 77.8C881.8 671 873 683 865 690.1c-6.4-20.8-15.6-33.6-27.9-39.1l-14.4-6.4-9.6 12.5c-13.3 17.6-29.8 37.8-38.1 46.6z"
          fill="#005BFF"
        ></path>
        <path
          d="M613 683.6c-0.3 0.9-0.7 1.8-1 2.7 0.4-0.9 0.7-1.8 1-2.7zM614.3 680.3c-0.3 0.7-0.6 1.4-0.8 2.1 0.3-0.8 0.5-1.5 0.8-2.1zM611.8 687c-0.4 1.1-0.7 2.2-1.1 3.4 0.4-1.2 0.7-2.3 1.1-3.4zM699.3 702.3c-0.4-0.4-0.7-0.8-1.1-1.2 0.4 0.4 0.8 0.8 1.1 1.2zM634 653.8l-1.8 1.2 1.8-1.2zM631.5 655.5l-1.2 0.9c0.5-0.3 0.9-0.6 1.2-0.9zM629.6 657.1c-0.3 0.3-0.6 0.6-1 0.9 0.3-0.3 0.7-0.6 1-0.9zM636 652.6l-1.5 0.9 1.5-0.9zM638.6 651.3c-0.7 0.3-1.4 0.6-2 1 0.7-0.4 1.4-0.7 2-1zM700.6 703.7c-0.3-0.4-0.7-0.7-1-1.1 0.3 0.3 0.7 0.7 1 1.1zM615.1 678.3c0 0.1-0.1 0.1-0.1 0.2 0.1-0.1 0.1-0.1 0.1-0.2zM627.2 659.4l-0.8 0.8 0.8-0.8zM621.4 666.7l-0.1 0.1s0-0.1 0.1-0.1zM620.1 668.6l-0.1 0.1c0.1 0 0.1 0 0.1-0.1zM623.8 663.3l-0.1 0.1 0.1-0.1zM625.4 661.3c-0.2 0.2-0.4 0.4-0.5 0.6 0.2-0.1 0.3-0.4 0.5-0.6zM817.7 454.3c0.8 1.7 1.5 3.4 2.3 5.2-0.7-1.7-1.5-3.5-2.3-5.2zM814.4 447.2c0.9 1.9 1.9 3.8 2.7 5.8-0.9-1.9-1.8-3.9-2.7-5.8zM830 488.1c0.5 1.9 1.1 3.9 1.6 5.8-0.6-1.9-1.1-3.8-1.6-5.8zM836.2 515.9c0.3 1.8 0.6 3.5 0.8 5.3-0.2-1.7-0.5-3.5-0.8-5.3zM823.1 467.3zM825.6 474.1c1.5 4.2 2.8 8.6 4.1 12.9-1.3-4.4-2.6-8.7-4.1-12.9zM820.4 460.3c0.9 2 1.7 4.1 2.5 6.2-0.9-2-1.7-4.1-2.5-6.2zM837.2 522.4l0.9 6.6-0.9-6.6zM835 509.3l0.9 5.1-0.9-5.1zM595.9 670.7c3.6 7.1 7.7 12.6 11.8 16.8-3-3.1-6.1-6.9-8.9-11.6-1-1.6-1.9-3.3-2.9-5.2z"
          fill="#005BFF"
        ></path>
        <path
          d="M668.4 664.8c-2-2.5-3.9-5-5.8-7.4 12.1 15.7 26.8 33.9 35.6 43.7-0.9-0.9-1.8-2-2.7-3.1-7.4-8.5-17.6-21-27.1-33.2zM834.7 508c-0.9-4.4-1.9-8.8-2.9-13.1 0.6 2.3 1.1 4.6 1.6 6.9 0.5 2.1 0.9 4.2 1.3 6.2zM839 537.3c0.1 1.6 0.3 3.1 0.4 4.7-0.1-1.6-0.3-3.1-0.4-4.7zM838.1 529c0.3 2.1 0.5 4.3 0.7 6.4-0.2-2.1-0.5-4.3-0.7-6.4zM839.6 544.2c0.1 1.6 0.2 3.1 0.3 4.7-0.1-1.5-0.2-3.1-0.3-4.7zM840 551c0.1 2.2 0.2 4.5 0.3 6.7-0.1-2.3-0.2-4.5-0.3-6.7zM590.9 658.4c-0.3-0.9-0.6-1.8-0.8-2.7 0.2 0.9 0.5 1.8 0.8 2.7zM592 661.7l-0.9-2.7c0.3 1 0.6 1.9 0.9 2.7zM609.2 689l-1.3-1.3 1.3 1.3zM589.8 654.9c-0.3-1.2-0.7-2.4-1-3.7 0.3 1.2 0.6 2.5 1 3.7zM595.9 670.7c-0.4-0.9-0.9-1.8-1.3-2.7 0.5 1 0.9 1.8 1.3 2.7zM783.4 400.9c1.4 1.6 2.7 3.2 4 4.8-1.3-1.6-2.6-3.2-4-4.8zM593.3 664.9c-0.4-0.9-0.7-1.8-1-2.7 0.3 0.9 0.6 1.8 1 2.7zM594.6 667.9l-1.2-2.7 1.2 2.7zM788.6 407c1 1.3 2 2.5 3 3.8-1-1.2-2-2.5-3-3.8zM804.2 429l3.3 5.4-3.3-5.4zM800.8 423.7c1 1.5 2 3.1 3 4.7-1-1.6-2-3.2-3-4.7zM808.2 435.7c0.9 1.5 1.7 3 2.5 4.5-0.8-1.6-1.6-3.1-2.5-4.5zM811.4 441.5zM792.5 412c1.3 1.6 2.5 3.3 3.7 5-1.2-1.6-2.4-3.3-3.7-5zM796.9 418c1 1.4 2 2.8 3 4.3-1-1.5-2-2.9-3-4.3z"
          fill="#005BFF"
        ></path>
        <path
          d="M735.5 464.2c-20.1 0-36.5 16.4-36.5 36.5s16.4 36.5 36.5 36.5 36.5-16.4 36.5-36.5-16.4-36.5-36.5-36.5z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M735.5 444.2c-31.2 0-56.5 25.4-56.5 56.5 0 31.2 25.4 56.5 56.5 56.5s56.5-25.4 56.5-56.5-25.3-56.5-56.5-56.5z m0 93.1c-20.1 0-36.5-16.4-36.5-36.5s16.4-36.5 36.5-36.5 36.5 16.4 36.5 36.5-16.4 36.5-36.5 36.5zM709 762.9c-5.5 0-10 4.5-10 10v99.4c0 5.5 4.5 10 10 10s10-4.5 10-10v-99.4c0-5.5-4.5-10-10-10z"
          fill="#06F3FF"
        ></path>
        <path
          d="M770.6 752.9c-11 0-20 9-20 20v28.8c0 11 9 20 20 20s20-9 20-20v-28.8c0-11.1-9-20-20-20zM678.3 255.1c2.1-5.1-0.3-11-5.4-13.1-78.2-32.3-135.6-15.6-170 4.1-37.3 21.4-55.8 50.4-56.6 51.6-2.9 4.7-1.5 10.8 3.1 13.8 1.7 1 3.5 1.5 5.3 1.5 3.3 0 6.6-1.7 8.5-4.7 0.2-0.3 16.6-26 49.6-44.9 44.3-25.4 95.6-26.4 152.4-3 5.1 2.3 11-0.2 13.1-5.3z"
          fill="#005BFF"
        ></path>
      </g>
    </svg>
  ),
  gitHub: ({ ...props }: LucideProps) => (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="github"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 496 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3 .7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3 .3 2.9 2.3 3.9 1.6 1 3.6 .7 4.3-.7 .7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3 .7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3 .7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
      ></path>
    </svg>
  ),
  google: ({ ...props }: LucideProps) => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        fill="#4285F4"
      />
      <path
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        fill="#34A853"
      />
      <path
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        fill="#EA4335"
      />
    </svg>
  ),
  help: HelpCircle,
  laptop: Laptop,
  logo: (props) => (
    <Image
      src="/images/logo-32.webp"
      alt="Logo"
      width={30}
      height={30}
      loading="eager"
      {...props}
    />
  ),
  moon: Moon,
  page: File,
  post: FileText,
  search: Search,
  Search: Search,
  settings: Cog,
  Settings: Settings,
  flask: FlaskRound,
  spinner: Loader2,
  sun: SunMedium,
  trash: Trash,
  menu: Menu,
  twitter: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="twitter"
      role="img"
      {...props}
    >
      <path
        d="M14.258 10.152L23.176 0h-2.113l-7.747 8.813L7.133 0H0l9.352 13.328L0 23.973h2.113l8.176-9.309 6.531 9.309h7.133zm-2.895 3.293l-.949-1.328L2.875 1.56h3.246l6.086 8.523.945 1.328 7.91 11.078h-3.246zm0 0"
        fill="currentColor"
      />
    </svg>
  ),
  user: User,
  warning: AlertTriangle,
};
